import { render, staticRenderFns } from "./DefaultChat.vue?vue&type=template&id=5b3b3aff&scoped=true"
import script from "./DefaultChat.vue?vue&type=script&lang=js"
export * from "./DefaultChat.vue?vue&type=script&lang=js"
import style0 from "./DefaultChat.vue?vue&type=style&index=0&id=5b3b3aff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3b3aff",
  null
  
)

export default component.exports